import { useCallback, useState } from "react";
import { deleteConversation } from "../../../services/conversationService";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export function useDeleteConversation(fetchConversation, onClose) {
  const [loading, setLoading] = useState(false);

  const handleDeleteConversation = useCallback(
    async (projectId, conversationId) => {
      setLoading(true);

      try {
        const response = await deleteConversation(projectId, conversationId);

        if (response.status === 200) {
          setLoading(false);
          fetchConversation(projectId);
          onClose();
          message.success("Conversation deleted");
        }
      } catch (e) {
        setLoading(false);
        onClose();
        showErrorToast(e, "Failed to delete conversation");
      }
    }
  );

  return {
    loading,
    handleDeleteConversation,
  };
}
